import { Avatar } from 'antd'
import React, { useState } from 'react'
import DynamicForm from '../../../../components/FormElements/DynamicForm'
import Button from '../../../../components/FormElements/Button'
import { FaStar } from 'react-icons/fa6'
import * as Yup from 'yup'
import useWindowSize from '../../../../config/hooks/utility/useWindowSize'


const ReviewInput = ({ data, response }) => {
    const [rating, setRating] = useState(0)
    const { width } = useWindowSize();
    
    const form = {
        name: 'reviewInputForm',
        formFields: [
            {
                name: 'comment',
                type: 'textarea',
                label: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                placeholder: 'Additional comments...',
                classes: '',
                icon: null,
            },
        ],
        formValidation: {
            comment: Yup.string().max(500).notRequired()
        }
    }

    const submitForm = () => {
        document.querySelector('form#reviewInputForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const handleSubmit = (values) => {
        const { comment } = values

        response({
            comment,
            rating
        })
    };

    const handleResetRating = (selectedIdx) => {
        setRating(selectedIdx == 0 ? selectedIdx : selectedIdx+1) 
    }
    
    return (
        <React.Fragment>
            {data && (
                <div className='flex flex-col items-center p-5 w-full '>
                    <div className='w-full flex justify-center'>
                        <Avatar
                            className='p-1 mb-2 rounded-full'
                            src={data?.imageThumbUrl}
                            size={width > 767 ? 90 : 70}
                        />
                    </div>
                    <h5 className='heading-5 font-bold mb-0'>{data?.fullName}</h5>
                    <p className='text-xs mb-2'>{data?.type}</p>
                    <div className='ratings sm:mr-2 mr-0 mb-2 flex rounded-md items-center justify-center items-center p-2'>
                        {/* rated stars count */}
                        {
                            Array(5).fill(0).map((el, index) => (
                                <FaStar 
                                    key={index} 
                                    className={`text-2xl w-[25px] ${rating >= index+1 ? 'text-primary' : 'text-gray-400'}`} 
                                    onClick={()=>setRating(index+1)}
                                    onDoubleClick={()=>handleResetRating(index)}
                                />
                            ))
                        }
                    </div>

                    <h5 className='heading-5 text-sm font-bold mb-6'>Describe Your Experience</h5>
                    <DynamicForm id="reviewInputForm" onSubmit={handleSubmit} form={form} />
                    <div className="flex justify-center w-full mb-2">
                        <Button.Basic 
                            onClick={submitForm}
                            disabled={false}
                            icon={null}
                            loading={false}
                            type="primary" 
                            size='medium'
                            text='Submit Review'
                            className='btn-primary w-full'
                        />
                    </div>
                </div>
            )}
        </React.Fragment>
    )
}

export default ReviewInput